import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Gallery from './components/Gallery';
import Menu from './components/Menu';
import Specials from './components/Specials';
import Reservation from './components/Reservation';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="bg-background-50 min-h-screen">
      <Navbar />
      <main>
        <Hero />
        <About />
        <Gallery />
        <Menu />
        <Specials />
        <Reservation />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}